"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(namespace) {
    return {
        TOGGLE_MODAL: `@sok/modules/userGroup/invite/${namespace}/TOGGLE_MODAL`,
        SELECT_ITEM: `@sok/modules/userGroup/invite/${namespace}/SELECT_ITEM`,
        ADD_ROW: `@sok/modules/userGroup/invite/${namespace}/ADD_ROW`,
        REMOVE_ROW: `@sok/modules/userGroup/invite/${namespace}/REMOVE_ROW`,
        UPDATE_EMAILS: `@sok/modules/userGroup/invite/${namespace}/UPDATE_EMAILS`,
        UPDATE_LANGUAGE: `@sok/modules/userGroup/invite/${namespace}/UPDATE_LANGUAGE`,
        INVITE_REQUEST: `@sok/modules/userGroup/invite/${namespace}/INVITE_REQUEST`,
        INVITE_SUCCESS: `@sok/modules/userGroup/invite/${namespace}/INVITE_SUCCESS`,
        INVITE_FAILED: `@sok/modules/userGroup/invite/${namespace}/INVITE_FAILED`,
        INVITE_VALIDATION: `@sok/modules/userGroup/invite/${namespace}/INVITE_VALIDATION`,
        CLEAR: `@sok/modules/userGroup/invite/${namespace}/CLEAR`
    };
}
exports.default = default_1;
//# sourceMappingURL=actionTypes.js.map